// extracted by mini-css-extract-plugin
module.exports = {"table":"EstimatedOrderSummary_table__TUOwc","uppercase":"EstimatedOrderSummary_uppercase__3BjWW"};